// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').LoaderConfig} LoaderConfig
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * - returns the current user if set; else
 * - checks the cache for a valid token and signs in with it
 * @callback LoadingAction
 * @param {ActionContext} ctx
 * @param {boolean|string|LoaderConfig} opts
 * @returns {void}
 *
 * @param {import('vuex').Store} store
 * @returns {LoadingAction}
 */
export const loading = (store) => (ctx, opts) => {
  if (typeof payload === 'boolean') opts = { loading: opts };
  if (typeof opts === 'string') opts = { loading: true, text: opts };
  ctx.commit('setState', opts || {});
};
